import { render, staticRenderFns } from "./CommunityList.vue?vue&type=template&id=36fc0f74&scoped=true&"
import script from "./CommunityList.vue?vue&type=script&lang=ts&"
export * from "./CommunityList.vue?vue&type=script&lang=ts&"
import style0 from "./CommunityList.vue?vue&type=style&index=0&id=36fc0f74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fc0f74",
  null
  
)

export default component.exports